import {useQuery} from '@tanstack/react-query';

import {getManagedMethods} from '../api';
import {QUERY__MANAGED_METHODS} from '../queryKeys';
import {ManagedMethodKind} from '../types';

export const useGetManagedMethods = (kind: ManagedMethodKind) => {
  return useQuery({
    queryKey: [QUERY__MANAGED_METHODS, kind],
    queryFn: () => getManagedMethods(kind),
  });
};
